import styled from 'styled-components'
import { CSS } from 'ui/helpers'

export const Columns = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
`

export const Table = styled.table`
  border-collapse: collapse;
`

export const Td = styled.td<{ $alerted?: boolean }>`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyM.regular)};
  padding: 9px 16px;
  text-align: center;
  border-right: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey100};
  background: ${(p) => (p.$alerted ? p.theme.uiKit.colors.theme.negative.main : 'transparent')};

  &:last-child {
    border-right: none;
  }
`

export const Th = styled.th<{ $bottomBorder?: boolean; $forceRightBorder?: boolean }>`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyM.semiBold)};
  color: ${(p) => p.theme.uiKit.colors.global.general.main};
  background: ${(p) => p.theme.uiKit.colors.global.grey.grey900};
  padding: 8px 30px;
  border-right: 1px solid ${(p) => p.theme.uiKit.colors.global.general.main};
  ${(p) => (p.$bottomBorder ? `border-bottom: 1px solid ${p.theme.uiKit.colors.global.general.main}` : '')};

  &:last-child {
    ${(p) => (!p.$forceRightBorder ? `border-right: none;` : ``)};
  }
`
